// src/hooks/useTimelineView.js

import { useState, useEffect } from "react";

export const useTimelineView = (key, defaultView = "grid") => {
  const storageKey = `timeline-view-${key}`;
  const [view, setView] = useState(() => {
    try { return localStorage.getItem(storageKey) || defaultView; }
    catch { return defaultView; }
  });
  useEffect(() => {
    try { localStorage.setItem(storageKey, view); } catch {}
  }, [view, storageKey]);
  return [view, setView];
};